import { HeaderTag } from '@bm-js/atlascloud-shared'
import { PropsWithChildren, useMemo } from 'react'

type TextTag = HeaderTag | 'span' | 'p'

type Props = {
  className?: string
  tag?: TextTag
  override?: boolean
}

const textStyles: Record<TextTag, string> = {
  h1: 'text-4xl font-bold',
  h2: 'text-3xl font-bold',
  h3: 'text-2xl font-bold',
  h4: 'text-xl font-bold',
  h5: 'text-lg font-bold',
  h6: 'text-base font-bold',
  p: 'text-base',
  span: 'text-base',
}

export const CText = ({
  tag = 'p',
  children,
  className,
  override,
}: PropsWithChildren<Props>) => {
  const TextTag = tag as keyof React.JSX.IntrinsicElements

  const classNames = useMemo(() => {
    if (override) {
      return className || ''
    }

    const defaultClass = textStyles[tag]
    return `${defaultClass} ${className || ''}`
  }, [className, override])

  return <TextTag className={classNames}>{children}</TextTag>
}
